import {Actions, AdminCheckbox} from './userComponents';

export const getAdminColumns = (sessionUsername, userState, setUserState, handleRowChange, handleApiError) => {
  return [
    {
      field: 'actions',
      headerName: "Actions",
      minWidth: 125,
      renderCell: params =>
        <Actions
          userId={params.row.user_id}
          userState={userState}
          isActive={params.row.active}
          handleApiError={handleApiError}
        />
    },
    {
      field: 'cognito_username',
      headerName: 'Username',
      minWidth: 225,
      valueFormatter: (value) => value === sessionUsername ? `${value} (you)` : value
    },
    {
      field: 'active',
      headerName: 'Status',
      valueGetter: (value) => value ? 'Active' : 'Inactive',
      cellClassName: (params) => params.value === 'Active' ? 'active-user' : 'inactive-user',
      minWidth: 115
    },
    // TODO add account_created after updating person API with field
    {
      field: 'is_admin',
      headerName: 'Admin',
      minWidth: 115,
      renderCell: params => (
        <AdminCheckbox
          userId={params.row.user_id}
          userState={userState}
          setUserState={setUserState}
          handleRowChange={handleRowChange}
        />
      )
    }
  ];
};